import Mousetrap from 'mousetrap'
import $ from 'jquery'

/** Extend mousetrap */
const _oldBind = Mousetrap.prototype.bind
const _originalStopCallback = Mousetrap.prototype.stopCallback
const _globalCallbacks = {}

Mousetrap.prototype.stopCallback = function (evt, element, combo, sequence) {
  if (this.paused) return true
  if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false
  return _originalStopCallback.call(this, evt, element, combo)
}

Mousetrap.prototype.bindGlobal = function (keys, callback, action) {
    this.bind(keys, callback, action)
    if (keys instanceof Array) {
      for (const key of keys) {
        _globalCallbacks[key] = true
      }
      return
    }
    _globalCallbacks[keys] = true
}

Mousetrap.prototype.bind = function (pattern, ...rest) {
    // Normal call
    if (typeof pattern === 'string' || pattern instanceof Array) {
        return _oldBind.call(this, pattern, ...rest)
    }

    // Object passed in
    for (const key in pattern) {
        if (Object.prototype.hasOwnProperty.call(pattern, key)) {
            _oldBind.call(this, key, pattern[key], ...rest)
        }
    }
}
Mousetrap.init()

/**
 * Sets up key bindings
 */
export default function setupKeyBindings (router) {
  const checkInput = fn => evt => {
    if (/INPUT|SELECT|TEXTAREA/.test(evt.target.tagName)
      || evt.target.isContentEditable) return
    fn(evt)
  }

  const goTo = route => checkInput(evt => {
    router.transitionTo(route)
  })

  $('.hotkeys-focus').focus()

  Mousetrap.bindGlobal('esc', evt => {
    evt.preventDefault()
    $(evt.target).blur()
  })

  Mousetrap.bind({
    'g r': goTo('my-records'),
    'g d': goTo('dashboard'),
    'g a': goTo('my-account'),
    'g e': goTo('events'),
    'g s': goTo('text-search'),
    'g m': goTo('map-search'),

    '/': evt => {
      evt.preventDefault()
      $('.hotkeys-search').focus()
    },

    's': evt => {
      evt.preventDefault()
      $('.redi-component-go-to-record .Select-input input').focus()
    },

    '\\': evt => {
      evt.preventDefault()
      $('.hotkeys-clear').click()
    },

    'c p': evt => $('.hotkeys-pub-prv-toggle :first').click(),
    'p': evt => $('.hotkeys-prev :first').click(),
    'n': evt => $('.hotkeys-next :first').click(),
    'e': evt => $('.hotkeys-edit:first').click(),

    'command+s': evt => { evt.preventDefault(); $('.hotkeys-save:first').click() },
    'ctrl+s': evt => { evt.preventDefault(); $('.hotkeys-save:first').click() },

    'command+z': evt => { evt.preventDefault(); $('.hotkeys-undo:first').click() },
    'ctrl+z': evt => { evt.preventDefault(); $('.hotkeys-undo:first').click() },

    'j': evt => {
      if (/hotkeys-select/.test(evt.target.className)) {
        $(evt.target).closest('tr').next().find('.hotkeys-select').focus()
      }
      else {
        $(evt.target).find('.hotkeys-select:first').focus()
      }
    },

    'k': evt => {
      if (/hotkeys-select/.test(evt.target.className)) {
        $(evt.target).closest('tr').prev().find('.hotkeys-select').focus()
      } else {
        $(evt.target).find('.hotkeys-select:last').focus()
      }
    }
  })
}



// WEBPACK FOOTER //
// ./modules/utils/setupKeyBindings.js